import type { Film } from '@/types/film';

export const films: Film[] = [
  {
    id: 'film-01',
    title: '星海回声',
    enTitle: 'Echoes of the Star Sea',
    type: 'movie',
    genres: ['科幻', '冒险'],
    region: '中国',
    year: 2026,
    director: '沈岸',
    cast: ['林知远', '苏婉清', '周牧'],
    duration: '142 分钟',
    rating: 9.1,
    heat: 2860000,
    synopsis:
      '一支深空勘探队在柯伊伯带边缘捕捉到来自三十年前的求救信号，随着信号被逐层解析，队员们发现当年的失踪者正是队长失踪多年的父亲。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20blue%20planet%2C%20deep%20navy%20and%20amber%20tones%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=qqc-p01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20deep%20space%20panorama%2C%20vast%20blue%20nebula%20and%20distant%20spacecraft%2C%20cinematic%20atmosphere%2C%20deep%20navy%20tones%20with%20warm%20amber%20highlights%2C%20high%20detail%20film%20still&width=1920&height=1080&seq=qqc-b01&orientation=landscape',
    tags: ['太空', '父子', '硬科幻'],
    featured: true,
  },
  {
    id: 'film-02',
    title: '银河候车室',
    enTitle: 'Waiting Room of the Galaxy',
    type: 'movie',
    genres: ['科幻', '爱情'],
    region: '中国',
    year: 2026,
    director: '许南',
    cast: ['程亦白', '江映月'],
    duration: '118 分钟',
    rating: 8.6,
    heat: 1720000,
    synopsis:
      '一座漂浮在轨道上的无人车站，每晚只停靠一班列车。两个等待同一趟车的人，在无限循环的候车夜里慢慢弄清了彼此与时间的秘密。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20retro%20train%20station%20floating%20in%20space%2C%20warm%20lantern%20light%20and%20deep%20blue%20universe%2C%20minimal%20composition%2C%20dreamy%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=qqc-p02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Surreal%20retro%20space%20station%20platform%20at%20night%2C%20warm%20lamps%20against%20deep%20blue%20starfield%2C%20cinematic%20wide%20shot%2C%20atmospheric%20film%20still&width=1920&height=1080&seq=qqc-b02&orientation=landscape',
    tags: ['时间循环', '治愈', '科幻爱情'],
  },
  {
    id: 'film-03',
    title: '星际幼儿园',
    enTitle: 'Galaxy Kindergarten',
    type: 'tv',
    genres: ['动画', '奇幻', '科幻'],
    region: '中国',
    year: 2026,
    director: '陆小满',
    cast: ['配音：叶童欣', '配音：谷一鸣'],
    duration: '全 26 集',
    rating: 8.9,
    heat: 1980000,
    synopsis:
      '银河系最乱糟糟的幼儿园里，五个来自不同星球的小朋友每天都要把教室炸一遍，而年轻的老师只想安稳地讲完一堂课。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20animation%20poster%20art%2C%20cute%20tiny%20aliens%20with%20children%20in%20a%20colorful%20spaceship%20classroom%2C%20playful%20warm%20orange%20and%20deep%20blue%20tones%2C%20no%20text&width=600&height=900&seq=qqc-p03&orientation=portrait',
    backdrop: '',
    tags: ['合家欢', '萌系', '单元剧'],
  },
  {
    id: 'film-04',
    title: '长夜未央',
    enTitle: 'The Long Night',
    type: 'movie',
    genres: ['悬疑', '犯罪'],
    region: '中国',
    year: 2025,
    director: '陈立言',
    cast: ['高砚', '宋清和', '谭野'],
    duration: '131 分钟',
    rating: 8.8,
    heat: 3120000,
    synopsis:
      '一桩尘封十七年的旧案在雨夜被重新翻出。退休刑警与当年唯一的目击者，必须在下一场雨落下之前找到那个从未存在的凶手。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20poster%20art%2C%20rainy%20neon%20city%20street%20at%20night%2C%20lone%20detective%20silhouette%20in%20the%20distance%2C%20deep%20navy%20and%20amber%20reflections%2C%20moody%20noir%20lighting%2C%20no%20text&width=600&height=900&seq=qqc-p04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Moody%20rainy%20city%20street%20at%20night%2C%20wet%20asphalt%20reflecting%20warm%20orange%20lights%2C%20deep%20blue%20shadows%2C%20cinematic%20noir%20film%20still%2C%20atmospheric&width=1920&height=1080&seq=qqc-b03&orientation=landscape',
    tags: ['雨夜', '旧案', '双线叙事'],
    featured: true,
  },
  {
    id: 'film-05',
    title: '雾都十二时',
    enTitle: 'Twelve Hours in the Fog',
    type: 'tv',
    genres: ['悬疑', '犯罪'],
    region: '英国',
    year: 2025,
    director: '亚瑟·布莱克',
    cast: ['艾略特·格雷', '汉娜·维尔'],
    duration: '全 8 集',
    rating: 9.0,
    heat: 2410000,
    synopsis:
      '浓雾笼罩的伦敦，十二小时内连续发生六起毫无关联的失踪案。一位被停职的钟表匠，发现所有案件都指向同一座停摆的钟楼。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20poster%20art%2C%20foggy%20Victorian%20London%20street%20with%20a%20tall%20clock%20tower%2C%20silhouettes%20in%20mist%2C%20deep%20blue%20and%20aged%20amber%20tones%2C%20no%20text&width=600&height=900&seq=qqc-p05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Thick%20fog%20over%20old%20London%20streets%2C%20gas%20lamps%20glowing%20warm%20orange%2C%20silhouette%20of%20a%20clock%20tower%20in%20the%20mist%2C%20cinematic%20period%20drama%20film%20still&width=1920&height=1080&seq=qqc-b04&orientation=landscape',
    tags: ['英伦', '推理', '限时'],
    featured: true,
  },
  {
    id: 'film-06',
    title: '夏日橘子汽水',
    enTitle: 'Orange Soda Summer',
    type: 'tv',
    genres: ['爱情', '青春'],
    region: '中国',
    year: 2025,
    director: '庄青禾',
    cast: ['夏栀', '顾屿', '何嘉禾'],
    duration: '全 24 集',
    rating: 8.4,
    heat: 3560000,
    synopsis:
      '海边小城的最后一个暑假，两个总在便利店门口相遇的高三学生，用一箱橘子汽水和一张手绘地图，交换了各自的秘密与未来。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20youth%20poster%20art%2C%20two%20teenagers%20riding%20bicycles%20along%20a%20summer%20seaside%20road%2C%20warm%20orange%20sunset%20light%2C%20soft%20film%20grain%2C%20nostalgic%20composition%2C%20no%20text&width=600&height=900&seq=qqc-p06&orientation=portrait',
    backdrop: '',
    tags: ['青春', '海边', '双向暗恋'],
  },
  {
    id: 'film-07',
    title: '钢铁黎明',
    enTitle: 'Steel Dawn',
    type: 'movie',
    genres: ['动作', '科幻'],
    region: '美国',
    year: 2025,
    director: '马库斯·里德',
    cast: ['凯文·罗斯', '艾琳·福斯特'],
    duration: '136 分钟',
    rating: 8.2,
    heat: 4280000,
    synopsis:
      '在能源枯竭的第七年，一支装甲小队奉命护送最后一批反应堆进入废墟之城，却发现他们要对抗的不是敌人，而是被改造过的自己。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20action%20poster%20art%2C%20futuristic%20armored%20soldier%20in%20ruined%20city%2C%20glowing%20orange%20sparks%20and%20cold%20blue%20smoke%2C%20dramatic%20high%20contrast%20lighting%2C%20no%20text&width=600&height=900&seq=qqc-p07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ruined%20futuristic%20city%20skyline%20at%20dawn%2C%20smoke%20and%20orange%20embers%2C%20cold%20blue%20haze%2C%20epic%20cinematic%20action%20film%20still&width=1920&height=1080&seq=qqc-b05&orientation=landscape',
    tags: ['末世', '机甲', '硬汉'],
    featured: true,
  },
  {
    id: 'film-08',
    title: '暗涌之城',
    enTitle: 'City of Undercurrents',
    type: 'tv',
    genres: ['犯罪', '悬疑'],
    region: '美国',
    year: 2025,
    director: '丹尼尔·科尔',
    cast: ['詹姆斯·卡特', '玛丽亚·洛佩兹'],
    duration: '全 10 集',
    rating: 8.7,
    heat: 2140000,
    synopsis:
      '港口城市的集装箱码头每天吞吐上万只箱子，也吞吐着没人愿意承认的秘密。一位女记者顺着一条错误报关单，走进了整座城市的背面。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20series%20poster%20art%2C%20harbor%20city%20docks%20at%20dusk%20with%20stacked%20containers%2C%20deep%20blue%20shadows%20and%20amber%20crane%20lights%2C%20noir%20atmosphere%2C%20no%20text&width=600&height=900&seq=qqc-p08&orientation=portrait',
    backdrop: '',
    tags: ['港口', '记者', '群像'],
  },
  {
    id: 'film-09',
    title: '春日放映厅',
    enTitle: 'Spring Screening Room',
    type: 'movie',
    genres: ['爱情', '剧情'],
    region: '韩国',
    year: 2025,
    director: '朴敏书',
    cast: ['李在勋', '金秀妍'],
    duration: '112 分钟',
    rating: 8.5,
    heat: 1480000,
    synopsis:
      '一家即将关门的老电影院，最后一位放映员和最后一位常客，用三十七天放完了他们都舍不得看完的那部电影。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20poster%20art%2C%20vintage%20cinema%20hall%20with%20warm%20projector%20light%20and%20empty%20seats%2C%20dust%20in%20the%20beam%2C%20nostalgic%20amber%20tones%2C%20no%20text&width=600&height=900&seq=qqc-p09&orientation=portrait',
    backdrop: '',
    tags: ['影院', '告别', '慢节奏'],
  },
  {
    id: 'film-10',
    title: '回声迷宫',
    enTitle: 'Labyrinth of Echoes',
    type: 'tv',
    genres: ['悬疑', '科幻'],
    region: '德国',
    year: 2025,
    director: '克劳斯·韦伯',
    cast: ['莉娜·霍夫曼', '托马斯·凯勒'],
    duration: '全 6 集',
    rating: 8.9,
    heat: 1320000,
    synopsis:
      '一座研究记忆的建筑里，所有房间都会复述你说过的话。当研究员听见自己从未说过的句子时，整座迷宫开始重新排列。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20poster%20art%2C%20surreal%20mirrored%20corridors%20with%20geometric%20light%2C%20cold%20blue%20and%20warm%20orange%20accents%2C%20minimal%20architectural%20composition%2C%20no%20text&width=600&height=900&seq=qqc-p10&orientation=portrait',
    backdrop: '',
    tags: ['记忆', '空间', '烧脑'],
  },
  {
    id: 'film-11',
    title: '无声证词',
    enTitle: 'Silent Testimony',
    type: 'movie',
    genres: ['犯罪', '悬疑'],
    region: '韩国',
    year: 2024,
    director: '郑宇成',
    cast: ['崔民浩', '韩素拉'],
    duration: '124 分钟',
    rating: 8.6,
    heat: 1960000,
    synopsis:
      '唯一的目击者是个听不见也说不出的人。为了让她的证词被法庭采纳，年轻律师必须用尽一切办法，让沉默本身成为证据。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20poster%20art%2C%20dark%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20silhouette%20of%20a%20person%2C%20deep%20navy%20shadows%20and%20amber%20light%2C%20no%20text&width=600&height=900&seq=qqc-p11&orientation=portrait',
    backdrop: '',
    tags: ['法庭', '无声', '反转'],
  },
  {
    id: 'film-12',
    title: '山与海的距离',
    enTitle: 'Between Mountain and Sea',
    type: 'tv',
    genres: ['剧情', '家庭'],
    region: '中国',
    year: 2024,
    director: '方致远',
    cast: ['罗大山', '倪静', '小演员：陈念'],
    duration: '全 30 集',
    rating: 9.2,
    heat: 2680000,
    synopsis:
      '山里的父亲一辈子没看过海，海边的女儿十年没回过家。一通误拨的电话，让两个人各自踏上了同一段反向的旅程。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20art%2C%20mountain%20village%20and%20distant%20sea%2C%20silhouettes%20of%20a%20father%20and%20daughter%2C%20warm%20dusk%20light%2C%20deep%20blue%20tones%2C%20no%20text&width=600&height=900&seq=qqc-p12&orientation=portrait',
    backdrop: '',
    tags: ['亲情', '返乡', '年代'],
  },
  {
    id: 'film-13',
    title: '深蓝之下',
    enTitle: 'Beneath the Deep Blue',
    type: 'movie',
    genres: ['剧情', '灾难'],
    region: '中国',
    year: 2024,
    director: '秦拓',
    cast: ['邵川', '林蔓', '赵启明'],
    duration: '128 分钟',
    rating: 8.3,
    heat: 1780000,
    synopsis:
      '深海钻井平台失联的第九个小时，一支救援小队下潜到四千米。他们要带回的不是设备，而是三个还活着的人。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20disaster%20poster%20art%2C%20deep%20ocean%20underwater%20with%20a%20submarine%20and%20searchlights%2C%20dark%20navy%20water%20and%20warm%20light%20beams%2C%20no%20text&width=600&height=900&seq=qqc-p13&orientation=portrait',
    backdrop: '',
    tags: ['深海', '救援', '工业'],
  },
  {
    id: 'film-14',
    title: '长安夜行',
    enTitle: 'Night Walk in Chang\'an',
    type: 'tv',
    genres: ['历史', '古装', '悬疑'],
    region: '中国',
    year: 2024,
    director: '裴子渊',
    cast: ['顾长风', '温如玉', '白十三'],
    duration: '全 36 集',
    rating: 8.8,
    heat: 3940000,
    synopsis:
      '长安宵禁之后，坊门紧闭，却总有人在夜里消失。一个替人送信的少年，和一柄不属于他的刀，卷入了整座城的暗流。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20historical%20Chinese%20poster%20art%2C%20ancient%20city%20at%20night%20with%20red%20lanterns%2C%20swordsman%20silhouette%20on%20a%20rooftop%2C%20deep%20blue%20night%20and%20warm%20amber%20glow%2C%20no%20text&width=600&height=900&seq=qqc-p14&orientation=portrait',
    backdrop: '',
    tags: ['古装', '悬疑', '长安'],
  },
  {
    id: 'film-15',
    title: '厨神小院',
    enTitle: 'The Little Courtyard Kitchen',
    type: 'tv',
    genres: ['喜剧', '剧情'],
    region: '中国',
    year: 2024,
    director: '马小川',
    cast: ['黄大海', '孙晴', '刘一勺'],
    duration: '全 20 集',
    rating: 8.1,
    heat: 2240000,
    synopsis:
      '一条老巷子里的小院饭馆，老板做菜全凭心情，客人点单全凭缘分。每天一顿饭，解决一个说不出口的心事。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20warm%20comedy%20poster%20art%2C%20small%20courtyard%20kitchen%20with%20steaming%20dishes%2C%20warm%20orange%20evening%20light%2C%20cozy%20Chinese%20courtyard%2C%20no%20text&width=600&height=900&seq=qqc-p15&orientation=portrait',
    backdrop: '',
    tags: ['美食', '治愈', '单元剧'],
  },
  {
    id: 'film-16',
    title: '最后一班地铁',
    enTitle: 'The Last Metro',
    type: 'movie',
    genres: ['爱情', '剧情'],
    region: '中国',
    year: 2024,
    director: '沈岸',
    cast: ['周牧', '苏婉清'],
    duration: '106 分钟',
    rating: 8.0,
    heat: 1620000,
    synopsis:
      '末班车上只有两个人。一个刚丢了工作，一个刚丢了行李。列车停运前的四十分钟，他们把这辈子的遗憾都讲完了。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20poster%20art%2C%20late%20night%20empty%20subway%20platform%20with%20two%20figures%2C%20cold%20blue%20fluorescent%20light%20with%20warm%20orange%20sign%2C%20no%20text&width=600&height=900&seq=qqc-p16&orientation=portrait',
    backdrop: '',
    tags: ['都市', '深夜', '对话'],
  },
  {
    id: 'film-17',
    title: '我们的旧时光',
    enTitle: 'Our Old Days',
    type: 'tv',
    genres: ['爱情', '青春'],
    region: '中国',
    year: 2023,
    director: '庄青禾',
    cast: ['江映月', '程亦白', '何嘉禾'],
    duration: '全 28 集',
    rating: 8.5,
    heat: 2380000,
    synopsis:
      '从高中教室到城市写字楼，一群人在十年里走散又重逢。青春不是一段时间，而是几个始终没换过的电话号码。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20youth%20poster%20art%2C%20vintage%20classroom%20with%20sunlight%20through%20windows%20and%20wooden%20desks%2C%20warm%20amber%20tones%2C%20soft%20film%20grain%2C%20no%20text&width=600&height=900&seq=qqc-p17&orientation=portrait',
    backdrop: '',
    tags: ['校园', '群像', '成长'],
  },
  {
    id: 'film-18',
    title: '雪原邮差',
    enTitle: 'The Snowfield Postman',
    type: 'movie',
    genres: ['剧情', '冒险'],
    region: '日本',
    year: 2022,
    director: '小林健太',
    cast: ['佐藤原', '中村雪'],
    duration: '119 分钟',
    rating: 8.4,
    heat: 980000,
    synopsis:
      '大雪封山的整个冬天，唯一的邮差要走三天才能送出一封信。今年他带的最后一封信，收件人已经不在了。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20quiet%20drama%20poster%20art%2C%20vast%20snowfield%20with%20a%20lone%20postman%20in%20a%20red%20coat%20walking%2C%20cold%20blue%20tones%20and%20warm%20red%20accent%2C%20no%20text&width=600&height=900&seq=qqc-p18&orientation=portrait',
    backdrop: '',
    tags: ['雪国', '孤独', '治愈'],
  },
  {
    id: 'film-19',
    title: '荒原信使',
    enTitle: 'The Wasteland Rider',
    type: 'movie',
    genres: ['冒险', '动作'],
    region: '美国',
    year: 2023,
    director: '马库斯·里德',
    cast: ['凯文·罗斯', '玛丽亚·洛佩兹'],
    duration: '115 分钟',
    rating: 7.9,
    heat: 1180000,
    synopsis:
      '荒漠里没有公路，也没有规则。一个靠送信活命的女人，为了一封不该送的信，得罪了整片荒原上最不该得罪的人。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20western%20poster%20art%2C%20lone%20rider%20crossing%20a%20red%20desert%20canyon%20with%20dust%20clouds%2C%20deep%20amber%20and%20navy%20sky%2C%20minimal%20epic%20composition%2C%20no%20text&width=600&height=900&seq=qqc-p19&orientation=portrait',
    backdrop: '',
    tags: ['公路', '西部', '女性'],
  },
  {
    id: 'film-20',
    title: '海边的旧唱片',
    enTitle: 'Old Vinyl by the Sea',
    type: 'movie',
    genres: ['剧情', '爱情'],
    region: '中国',
    year: 2022,
    director: '许南',
    cast: ['倪静', '林知远'],
    duration: '102 分钟',
    rating: 8.2,
    heat: 860000,
    synopsis:
      '搬家时翻出的一张旧唱片，让女儿第一次听清了母亲年轻时唱过的歌。有些人的一生，只留下三分钟的录音。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20music%20drama%20poster%20art%2C%20old%20vinyl%20record%20on%20a%20windowsill%20overlooking%20the%20sea%2C%20warm%20sunset%20light%2C%20dusty%20nostalgic%20tones%2C%20no%20text&width=600&height=900&seq=qqc-p20&orientation=portrait',
    backdrop: '',
    tags: ['音乐', '母女', '海边'],
  },
];